import { render, staticRenderFns } from "./Proximamente.vue?vue&type=template&id=65988d62&scoped=true&"
import script from "./Proximamente.vue?vue&type=script&lang=js&"
export * from "./Proximamente.vue?vue&type=script&lang=js&"
import style0 from "./Proximamente.vue?vue&type=style&index=0&id=65988d62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65988d62",
  null
  
)

export default component.exports